import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { translate, formatData, downloadFile, getUserNameToName, closeCollapsible } from '../../../../utils/util';
import { Input, BackButton, Title, Button, ListPagination, Collapsible } from '../../../../components/UI/ComponentsUI';
import { onValueChange } from '../../../../utils/handleChangeHooks';
import StockService from '../../../../services/StockService';
import { isNullOrEmpty } from '../../../../utils/util';

const Report = (props) => {
    const [currentPage, setCurrentPage] = useState(0);
    const [logs, setLogs] = useState([]);
    const [filter, setFilter] = useState(
        {
            inicialDate: "",
            finalDate: "",
            area: "",
            partNumber: "",
            barCode: "",
            upload: true
        });

    useEffect(() => {
        if (props.logs?.items?.length > 0) {
            if (logs.length > 0 && currentPage === 0) {
                setLogs([...props.logs.items]);
            } else {
                setLogs((prevState) => ([...prevState, ...props.logs.items]));
            }
        } else {
            setLogs([]);
        }
        // eslint-disable-next-line
    }, [props?.logs?.items]);

    const getLogFilter = (click) => {
        var currentPageList = click ? 0 : currentPage;
        if (click) {
            setCurrentPage(0);
        }
        props.getLogs(Object.assign(filter, {
            PageSize: 25,
            PageIndex: currentPageList
        }), () => {
            closeCollapsible('collapsible')
        });
    }

    const onChange = (event) => {
        onValueChange(event, filter, setFilter);
    };

    useEffect(() => {
        if (currentPage > 0) {
            getLogFilter(false);
        }
        // eslint-disable-next-line
    }, [currentPage]);

    const downloadReport = () => {
        props.getReport(filter, (data) => {
            downloadFile(data, `ReportDiffusion${Date.now()}.xlsx`, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", true)
        });
    }

    const renderQtdDownload = (data) => {
        if (!isNullOrEmpty(data.jsonResponse)) {
            try {
                return `Qtd. Baixada ${JSON.parse(data.jsonResponse)?.QTDBAIXADA}`;
            } catch (error) {
                console.error(error)
            }
        }
    }

    return (
        <div>
            <BackButton {...props} />
            <div className="container-fluid h-65">
                <Title icon="mdi mdi-clipboard-list-outline" label={translate('change-location:menu.reportUpload')} />
            </div>
            <div className="container-fluid" style={{ marginTop: '20px' }}>
                <div className="container" style={{ marginTop: '0px', }}>
                    <Collapsible
                        id="collapsible"
                        header={translate('filter', 'physical-confirmation')}
                        body={
                            <form id="getLogs" className="col s12">
                                <div className="row" style={{ padding: '10px' }}>
                                    <div className="input-field col s6 no-padding m5">
                                        <Input
                                            defaultValue={filter.inicialDate}
                                            type="date"
                                            label={translate('date-start', 'truck-kanban')}
                                            id="inicialDate"
                                            name="inicialDate"
                                            onChange={onChange}
                                        />
                                    </div>
                                    <div className="input-field col s5 no-padding m5">
                                        <Input
                                            defaultValue={filter.finalDate}
                                            type="date"
                                            label={translate('date-end', 'truck-kanban')}
                                            id="finalDate"
                                            name="finalDate"
                                            onChange={onChange}
                                        />
                                    </div>
                                    <div className="input-field col s6 no-padding m6">
                                        <Input
                                            label={translate('stock:area')}
                                            id="area"
                                            name="area"
                                            type="text"
                                            onChange={onChange}
                                            defaultValue={filter?.area}
                                        />
                                    </div>
                                    <div className="input-field col s5 no-padding m5">
                                        <Input
                                            label={translate('stock:cim')}
                                            id="barcode"
                                            name="barcode"
                                            type="text"
                                            maxLength={10}
                                            onChange={onChange}
                                            defaultValue={filter?.barCode}
                                        />
                                    </div>
                                    <div className="input-field col s11 no-padding" >
                                        <Input
                                            label={translate('stock:partnumber')}
                                            id="partNumber"
                                            name="partNumber"
                                            type="text"
                                            onChange={onChange}
                                            defaultValue={filter?.partNumber}
                                        />
                                    </div>
                                </div>
                            </form>
                        }
                    />
                    <div className="row" style={{ paddingTop: '5px' }}>
                        <Button full="true" text={translate('stock:search')} onClick={() => getLogFilter(true)} />
                    </div>
                    {
                        logs.length > 0 && navigator.userAgent !== 'logisticspwa' &&
                        <div className="row" style={{ paddingTop: '5px' }}>
                            <Button onClick={downloadReport} full="true" text={translate('general.generateReport')} />
                        </div>
                    }
                </div>
                <div id="loglist">
                    <ListPagination
                        page={props?.logs?.totalPages}
                        current={{ currentPage, setCurrentPage }}
                        data={logs.map((item) => (
                            <div
                                className="row"
                                style={{ display: 'block', marginBottom: '0px', marginLeft: '0px' }}
                            >
                                {
                                    !isNullOrEmpty(item.area) &&
                                    <span className="title sixth-text-color" style={{ display: 'block' }} >
                                        {item.area}
                                    </span>
                                }
                                {
                                    !isNullOrEmpty(item.partNumber) &&
                                    <span className="title sixth-text-color" style={{ display: 'block' }} >
                                        {item.partNumber}
                                    </span>
                                }
                                {
                                    !isNullOrEmpty(item.barCode) &&
                                    <span className="title sixth-text-color" style={{ display: 'block' }} >
                                        {item.barCode}
                                    </span>
                                }
                                {
                                    !isNullOrEmpty(item.fileName) &&
                                    <div>
                                        <span className="title sixth-text-color" style={{ display: 'block' }} >
                                            {item.fileName}
                                        </span>
                                        <span className="title sixth-text-color" style={{ display: 'block' }} >
                                            {formatData(item.inicialDate)} - {formatData(item.finalDate)}
                                        </span>
                                    </div>
                                }
                                {
                                    <span className="title sixth-text-color" style={{ display: 'block' }} >
                                        {item?.success && renderQtdDownload(item)}
                                    </span>
                                }
                                {
                                    !item?.success ?
                                        <div className="col s12 second-text-color"  >
                                            {translate('line-picking:transmission.erro-send')} - {formatData(item.createdOn)}
                                        </div>
                                        : <div className="col s12 second-text-color"  >
                                            {translate('line-picking:transmission.send')} - {formatData(item?.createdOn || '')}
                                        </div>
                                }
                                <div>
                                    <span className="col s12 second-text-color" style={{ display: 'block' }} >{item?.createdBy} - {getUserNameToName(props.usersFromElog, item?.createdBy)}
                                    </span>
                                </div>
                            </div>
                        ))}
                    />
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        logs: state.stockReducer.logs,
        usersFromElog: state.usersElogReducer.usersElog
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getReport: (filter, callback) => {
            dispatch(StockService.getReport(filter, callback));
        },
        getLogs: (filter, callback) => {
            dispatch(StockService.getLogsPaged(filter, callback));
        }
    }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Report)));
